export default {
    licenseKey: '0eZ7YSVWq8iU/FYjw90+h1REcQR42Giej+ULQdrmVOkm1Y2h',
  };